$.fn.FiltersMobile = function(parent) {
  let self = this

  if (self.data('filters-mobile')) {
    return self.data('filters-mobile')
  }

  self.max_height = 0
  self.toggle_btn = self.find('.filters-list__title')
  self.content = self.find('.filters-list__items')

  self.toggle_mobile = function() {
    self.toggle_btn.attr('aria-expanded', 'false').on('click', self.toggle_clicked)
    self.content.attr('aria-hidden', 'true')
  }

  self.toggle_desktop = function() {
    self.toggle_btn.attr('aria-expanded', '').off('click')
    self.content.attr('aria-hidden', '').css('max-height', '')
  }

  self.calculate_height = function() {
    if ($.mlmi.mobile.isMobile) {
      self.max_height = 0
      self.find('.filters-list__item').each(function() {
        self.max_height += $(this).outerHeight(false)
      })
      if (self.content.attr('aria-hidden') === 'false') {
        self.content.css('max-height', self.max_height + 'px')
      }
    }
  }

  self.toggle_clicked = function() {
    if ($.mlmi.mobile.isMobile) {
      parent.lists.css('max-height', '')
      if (self.toggle_btn.attr('aria-expanded') === 'false') {
        self.toggle_btn.attr('aria-expanded', 'true')
        self.content.attr('aria-hidden', 'false').css('max-height', self.max_height + 'px')
      } else if (self.toggle_btn.attr('aria-expanded') === 'true') {
        self.toggle_btn.attr('aria-expanded', 'false')
        self.content.attr('aria-hidden', 'true').css('max-height', '')
      }
    }
  }

  self.maybe_close = function() {
    self.toggle_btn.attr('aria-expanded', 'false')
    self.content.attr('aria-hidden', 'true').css('max-height', '')
  }

  return function() {
    $.mlmi.mobile.add(self.toggle_mobile, self.toggle_desktop)
    $(window).on('load resize orientationchange', self.calculate_height)
    self.calculate_height()
    self.data('filters-mobile', self)
    return self
  }()
}

$.fn.FiltersPanel = function(filters) {
  let self = this

  self.mobile_lists = []
  self.toggle_btn = self.find('.filters__toggle-btn')
  self.reset_btn = self.find('.filters__reset-btn')
  self.lists = self.find('.filters__lists')
  self.checkboxes = self.find ('input[type="checkbox"]')
  self.max_height = 0

  self.toggle_clicked = function() {
    if (self.toggle_btn.attr('aria-expanded') === 'true') {
      self.toggle_btn.attr('aria-expanded', 'false')
      self.lists.css('max-height', '')
      self.lists.attr('aria-hidden', 'true')
      setTimeout(function() {
        self.mobile_lists.forEach(function(mobileList) {
          mobileList.maybe_close()
        })
      }, 325)
    } else {
      self.toggle_btn.attr('aria-expanded', 'true')
      self.lists.css('max-height', self.max_height + 'px')
      self.lists.attr('aria-hidden', 'false')
    }
  }

  self.reset_clicked = function() {
    self.checkboxes.prop('checked', false)
    filters.changed()
  }

  self.calculate_height = function() {
    self.max_height = 0
    if ($.mlmi.mobile.isMobile) {
      self.find('.filters-list').each(function() {
        if ($(this).outerHeight(false) > self.max_height) {
          self.max_height += $(this).outerHeight(false)
        }
      })
    } else {
      self.find('.filters-list').each(function() {
        if ($(this).outerHeight(false) > self.max_height) {
          self.max_height = $(this).outerHeight(false)
        }
      })
    }
    if (self.lists.attr('aria-hidden') === 'false') {
      self.lists.css('max-height', self.max_height + 'px')
    }
  }

  return function() {
    if (self.hasClass('filters--mobile')) {
      self.find('.filters-list').each(function() {
        let mobileList = $(this).FiltersMobile(self)
        self.mobile_lists.push(mobileList)
      })
    }
    $(window).on('load resize orientationchange', self.calculate_height)
    self.calculate_height()
    self.toggle_btn.on('click', self.toggle_clicked)
    self.reset_btn.on('click', self.reset_clicked)
    return self
  }()
}

$.fn.Filters = function() {
  let self = this

  if (self.data('filters')) {
    return self.data('filters')
  }

  self.fields = self.find(':input')
  self.filters = {}
  self.filters_string = ''
  self.filters_hash = ''
  self.changing_hash = false
  self.grid = $('.grid')
  self.default_order = [];
  self.cells = self.grid.find('.grid__item')

  self.grid.find('.grid__item').each(function() {
    self.default_order.push(Number($(this).attr('data-id')))
  })

  self.changed = function(e) {
    self.filters = {}
    let filters_hash = ''
    self.find(':input:checked').each(function() {
      let field_name = $(this).attr('name'),
      field_value = $(this).val()
      if (self.filters[field_name] == undefined) {
        self.filters[field_name] = []
      }
      self.filters[field_name].push(field_value)
      if (filters_hash == '') {
        filters_hash += '#'
      } else {
        filters_hash += ','
      }
      filters_hash += field_value
    })
    if (filters_hash == '#') {
      filters_hash = ''
    }

    if (JSON.stringify(self.filters) == self.filters_string) {
      return
    }
    self.filters_string = JSON.stringify(self.filters)
    self.filters_hash = filters_hash
    self.changing_hash = true
    window.location.hash = self.filters_hash

    self.grid.fadeOut(250, function() {
      self.grid.addClass('grid--filtered')
      self.cells.each(function(index, el) {
        let cell = $(el),
        card = cell.find('a[class*="card-"]')
        cell.fails_check = false
        cell.attr('aria-hidden', 'false')
        for (var key in self.filters) {
          let has_term = false
          self.filters[key].forEach(function(x) {
            if ($.inArray(x, card.data(key)) !== -1) {
              has_term = true
            }
          })
          if (!has_term) {
            cell.fails_check = true
          }
        }
        if (cell.fails_check) {
          cell.attr('aria-hidden', 'true')
        }
      })
      if (!self.find(':input:checked').length) {
        self.grid.removeClass('grid--filtered')
      }
      if (!self.cells.filter('[aria-hidden="false"]').length) {
        // empty results
      }
      var sorting_array = self.default_order
      if (typeof self.filters.expertise !== 'undefined' && self.filters.expertise.length == 1) {
        var expertise_array = JSON.parse(self.find('input[value=' + self.filters.expertise[0] + ']').attr('data-projects-order'))[0]
        if (typeof expertise_array !== 'undefined') {
          sorting_array = expertise_array;
        }
      }
      let $items = self.grid.find('.grid__item').detach().sort(function(a, b) {
        var a = sorting_array.indexOf(Number(a.dataset.id));
        if (a == -1) {
          a = 999;
        }
        var b = sorting_array.indexOf(Number(b.dataset.id));
        if (b == -1) {
          b = 999;
        }
        return a - b;
      });
      self.grid.append($items)
      self.grid.fadeIn(350)
    })
  }

  self.read_hash = function() {
    if (self.changing_hash) {
      self.changing_hash = false
      return
    }
    self.find('input[type="checkbox"]').prop('checked', false)
    if (window.location.hash) {
      self.hash_filters = window.location.hash.substr(1).split(',')
      self.hash_filters.forEach(function(x) {
        self.find('input[type="checkbox"][value="' + x + '"]').prop('checked', true).trigger('change')
      })
    }
    self.changed()
  }

  return function() {
    self = self.FiltersPanel(self)
    self.fields.on('change', self.changed)
    self.read_hash()
    $(window).on('hashchange', self.read_hash)
    self.data('filters', self)
    return self
  }()
}
